// Special markers for virtual beginning and ending events
export const BEGINNING_MARKER = '__BEGINNING__';
export const ENDING_MARKER = '__ENDING__';

